export default __webpack_public_path__ + "static/media/What-is-a-Factory-of-the-future-Infographic.201873d1.pdf";